// Inline SVG rather than image files: no Salesforce/HubSpot assets ship with
// this app, and inlining keeps the cards from rendering broken images. Swap in
// official brand assets here if/when they are added to /public/images.
//
// Note for the HubSpot marketplace listing: HubSpot's brand guidelines restrict
// use of the sprocket mark, so this is a neutral geometric stand-in rather than
// a reproduction of their logo.

export const SalesforceLogo = () => (
    <svg width="34" height="34" viewBox="0 0 24 24" role="img" aria-label="Salesforce">
        <path
            fill="#00A1E0"
            d="M10.2 6.1a3.5 3.5 0 0 1 5.7.8 4 4 0 0 1 1.6-.35 4.05 4.05 0 0 1 0 8.1H16a3.1 3.1 0 0 1-4.3 1.35 3.55 3.55 0 0 1-6.55-.6A3.35 3.35 0 1 1 5.9 8.7a3.5 3.5 0 0 1 4.3-2.6Z"
        />
    </svg>
);

export const HubspotLogo = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="HubSpot">
        <circle cx="12" cy="13.6" r="4.1" fill="none" stroke="#FF7A59" strokeWidth="2.1" />
        <circle cx="18.4" cy="5.6" r="2.3" fill="#FF7A59" />
        <path d="M12 9.5V7.2M12 7.2h2.6" fill="none" stroke="#FF7A59" strokeWidth="2.1" strokeLinecap="round" />
    </svg>
);
